import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Users, Calendar, Flame, ArrowRight } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { CommunityCard, EventCard, ChallengeCard, ProjectCard, ListingCard } from "@/components/cards";
import { Loader, SectionHeader, EmptyState } from "@/components/ui-bits";

export default function PassionDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { setP(null); api.get(`/passions/${slug}`).then((r) => setP(r.data)); }, [slug]);
  if (!p) return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"><Loader /></div>;

  const stats = [
    { icon: Users, v: p.communities?.length || 0, l: "Communities" },
    { icon: Calendar, v: p.events?.length || 0, l: "Events" },
    { icon: Flame, v: p.challenges?.length || 0, l: "Challenges" },
  ];

  return (
    <div>
      <div className="relative h-56 sm:h-72">
        <img src={fileUrl(p.cover)} alt={p.title} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#071126] via-[#071126]/50 to-[#071126]/10" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-6 text-white">
          <p className="text-xs uppercase tracking-wider text-[#FFC94A] font-semibold">{p.category}</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mt-1">{p.title}</h1>
          <p className="max-w-2xl text-white/80 mt-2">{p.description}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-12">
        <div className="grid grid-cols-3 gap-4 -mt-14 relative">
          {stats.map((s) => (
            <div key={s.l} className="pa-card p-5 text-center">
              <s.icon className="h-5 w-5 text-[#FF6B00] mx-auto" />
              <p className="text-2xl font-bold text-[#071126] mt-1">{s.v}</p>
              <p className="text-xs text-[#55708F] font-medium">{s.l}</p>
            </div>
          ))}
        </div>

        <section>
          <SectionHeader title="Communities"
            action={<Link to={`/communities?passion=${slug}`} className="text-sm font-semibold text-[#FF6B00] inline-flex items-center gap-1">All<ArrowRight className="h-4 w-4" /></Link>} />
          {p.communities?.length ? <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{p.communities.map((c) => <CommunityCard key={c.id} c={c} />)}</div>
            : <EmptyState icon={Users} title="No communities yet" hint="Be the first to create one." />}
        </section>

        {p.events?.length > 0 && <section><SectionHeader title="Upcoming events" /><div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{p.events.map((e) => <EventCard key={e.id} e={e} />)}</div></section>}
        {p.challenges?.length > 0 && <section><SectionHeader title="Challenges" /><div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{p.challenges.map((c) => <ChallengeCard key={c.id} c={c} />)}</div></section>}
        {p.projects?.length > 0 && <section><SectionHeader title="Featured creations" /><div className="grid gap-5 grid-cols-2 lg:grid-cols-4">{p.projects.map((x) => <ProjectCard key={x.id} p={x} />)}</div></section>}
        {p.listings?.length > 0 && <section><SectionHeader title="From the marketplace" /><div className="grid gap-5 grid-cols-2 lg:grid-cols-4">{p.listings.map((l) => <ListingCard key={l.id} l={l} />)}</div></section>}
      </div>
    </div>
  );
}
